import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TenantUIService } from 'src/app/pages/tenant/tenant-ui.service';
import { ActionService } from 'src/app/services/actions/action.service';
import { UtilitiesDate } from 'src/app/services/utilities.date';
import * as moment from 'moment';
import { DecimalPipe } from '@angular/common';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-ingestion-item-detail',
  templateUrl: './ingestion-item-detail.component.html',
  styleUrls: ['./ingestion-item-detail.component.scss'],
  providers: [DecimalPipe]
})
export class IngestionItemDetailComponent implements OnInit {

  @Input() approvalItem: any;
  @Input() multiplier: number;

  @ViewChild('dtEndDates', { static: false }) public dtEndDates : Table;

  endDates: any[] = [];
  showEndDateDetails = false;
  showDialog = false;

  meanValue: number;
  stdDevValue: number;
  threshold: number;

  chartData = {
    labels: ['January', 'February', 'March'],
    datasets: [
      {
        type: 'bar',
        label: 'End Date Counts',
        data: [5, 6, 7],
        backgroundColor: ['rgba(54, 162, 235, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(54, 162, 235, 0.2)'],
        borderColor: 'white',
        borderWidth: 0
      },
      {
        type: 'line',
        label: 'Threshold',
        data: [5, 6, 7],
        backgroundColor: ['rgba(54, 162, 235, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(54, 162, 235, 0.2)'],
        borderColor: 'red',
        borderDash: [5, 5],
        pointRadius : 0
      }
    ]
  };

  chartOptions = {
    maintainAspectRatio: false,
    aspectRatio: 0.6,
    plugins: {
      legend: {
        labels: {
          color: "black"
        }
      }
    },
    scales: {
      x: {
        ticks: {
          color: "grey"
        },
        grid: {
          color: "white",
          drawBorder: false
        }
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: "darkgrey"
        },
        grid: {
          color: "lightgrey",
          drawBorder: false
        }
      }
    }
  };

  constructor(private actionService: ActionService,
    protected service: TenantUIService,
    private decimalPipe: DecimalPipe
  ) {
    this.showEndDateDetails = false;
    this.showDialog = false;
  }

  async ngOnInit() {
  }

  endDateDetailColumns = [{ field: 'state', header: 'State' },
    { field: 'memberId', header: 'MemberId' },
    { field: 'hicn', header: 'HICN' },
    { field: 'hContract', header: 'HContract' },
    { field: 'medicaidStatusEndDate', header: 'End Date' },
    { field: 'fileGenerationDate', header: 'File Date' }];

  exporting = false;

  export() {
    this.exporting = true;
    setTimeout(() => {
      this.dtEndDates.exportCSV();
      this.exporting = false;
    }, 500);
  }

  async showDetails(item) {

    let response = await this.actionService.invoke("Ingestion", "get-enddates", {
      tenantId: this.service.selectedTenant.tenantName,
      state: this.approvalItem.state,
      hContract: this.approvalItem.hContract,
      endDate: item.medicaidStatusEndDate,
      fileGenerationDate: item.fileGenerationDate
    });

    this.endDates = response.endDates;

    this.showEndDateDetails = true;
  }

  endDateClicked(item) {
    const dateString = this.getDateMMDDYYYY(item.medicaidStatusEndDate);

    return this.approvalItem.RejectionChipsArray.includes(dateString);
  }

  formatNumber(value: number): string {
    return this.decimalPipe.transform(value, '1.2-2');
  }

  get thresholdTooltip() {
    return "Average + (" + this.multiplier + " * Std Dev)" + "\n" +
           "Std Dev= " +
           this.formatNumber(this.stdDevValue);
  }

  addEndDateClicked(item) {
    if (!this.approvalItem.RejectionCriteria) {
      this.approvalItem.RejectionCriteria = [];
    }

    const dateString = this.getDateMMDDYYYY(item.medicaidStatusEndDate);

    if (!this.approvalItem.RejectionChipsArray.includes(dateString)) {
      this.addChipToApproval(dateString, this.approvalItem);
    }
  }

  getDateMMDDYYYY(date: string) {
    let utcDate = moment.utc(date);
    return utcDate.local().format('MM/DD/yyyy');
  }

  addChipToApproval(chipText: string, approval: any) {
    approval.RejectionCriteria.push({
      Field: "MedicaidStatusEndDate",
      Value: chipText,
      Operator: "="
    });

    approval.RejectionChipsArray = approval.RejectionCriteria.map(x => x.Value);
  }

  async showDetailsDialog() {
    if (this.approvalItem.outliers && this.approvalItem.outliers.length > 0) {
      this.meanValue = this.approvalItem.outliers[0].meanValue;
      this.stdDevValue = this.approvalItem.outliers[0].stdDevValue;
      this.threshold = this.approvalItem.outliers[0].threshold;

      // let response = await this.actionService.invoke("Ingestion", "get-counts", {
      //   tenantId: this.service.selectedTenant.tenantName,
      //   state: this.approvalItem.state,
      //   hContract: this.approvalItem.hContract
      // });

      // const endDateCountsForContract = response.counts;

      this.chartData.labels = this.approvalItem.endDateCountsForContract.map(x => this.getDateMMDDYYYY(x.endDate));
      this.chartData.datasets[0].data = this.approvalItem.endDateCountsForContract.map(x => x.count);

      const dataPointCount = this.chartData.datasets[0].data.length;

      this.chartData.datasets[0].backgroundColor = [];
      this.chartData.datasets[1].backgroundColor = [];
      this.chartData.datasets[1].data = [];

      for (let i = 0; i < dataPointCount; i++) {
        const itemEndDateFormatted = this.getDateMMDDYYYY(this.approvalItem.endDateCountsForContract[i].endDate);
        const isOutlier = this.approvalItem.outliers.some(x => this.getDateMMDDYYYY(x.medicaidStatusEndDate) == itemEndDateFormatted);

        if (isOutlier) {
          this.chartData.datasets[0].backgroundColor.push('rgba(255, 0, 0, 0.5)');
        } else {
          this.chartData.datasets[0].backgroundColor.push('lightgrey');
        }

        this.chartData.datasets[1].backgroundColor.push('white');

        this.chartData.datasets[1].data.push(this.threshold + this.meanValue);
      }

      this.showDialog = true;
    }
  }


  getToolTip(app: any) {
    // var sampleResponseItem = {
    //         "state": "AL",
    //         "hContract": "H0432",
    //         "fileGenerationDate": "2024-10-05T12:00:00",
    //         "medicaidStatusEndDate": "2024-07-31T12:00:00",
    //         "occurrenceCount": 43,
    //         "meanValue": 5,
    //         "stdDevValue": 7.828029686995815,
    //         "differenceFromMean": 38,
    //         "threshold": 15.65605937399163,
    //         "significance": "Significant"
    // };

    if (!app) {
      return "";
    }
    if (!(app.outliers && app.outliers.length > 0)) {
      return "";
    }

    let responseText = "";
    for (const o of app.outliers) {
      if (o.fileGenerationDate == app.fileGenerationDate) {
        responseText += UtilitiesDate.formatDate(o.medicaidStatusEndDate, 'MM/dd/yyyy') + " : " + o.occurrenceCount + "\n";
      }
    }

    return responseText;
  }


}
